<lib-modal-layout [title]="title" [subtitle]="subtitle">
  @if (currentStep === 1) {
  <p class="text-center">Enter the following details to create your agency.</p>
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <lib-ui-agency-form
      formControlName="agencyForm"
      [states]="lookupStore.states() ?? []"
      [programs]="lookupStore.programs() ?? []"
    ></lib-ui-agency-form>
    <div class="text-center">
      <lib-button
        [cssType]="'btn-primary'"
        [icon]="'rightarrow'"
        [text]="'Continue'"
        [size]="'large'"
        [type]="'submit'"
        [disabled]="!form.valid"
      ></lib-button>
    </div>
  </form>
  } @else if (currentStep === 2) {
  <p class="text-center">Enter the email address for agency users.</p>
  <lib-ui-agency-users-form
    #usersForm
    [roles]="lookupStore.agencyRoles() ?? []"
    [agencyId]="agencyId()"
    (formSubmit)="submitUsersForm($event)"
  >
  </lib-ui-agency-users-form>

  <div class="text-center">
    <p class="m-3 mb-5">
      An invitation email will be sent to these users with instructions to complete their registration.
    </p>
    <div>
      <lib-button
        [cssType]="'btn-primary'"
        [icon]="'rightarrow'"
        [text]="'Invite Users'"
        [size]="'large'"
        (click)="usersForm.submit()"
      ></lib-button>
      <div class="py-3">
        <lib-button
          class="primary bold"
          [cssType]="'btn-link'"
          [text]="'Back to Previous Step'"
          [size]="'large'"
          [type]="'button'"
          (click)="currentStep = 1"
        ></lib-button>
      </div>
    </div>
  </div>
  }
</lib-modal-layout>
